import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, NgModule, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'vertical-timeline',
  template: '<section class="timeline"><ng-content></ng-content></section>',
  styles: [`
    .timeline { display: block; position: relative; padding: 24px 0; }
    .timeline::before { content: ''; position: absolute; top: 0; bottom: 0; left: 50px; width: 4px; background: #c5cae9; }
  `],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class VerticalTimelineComponent {}

@Component({
  selector: 'vertical-timeline-card',
  template: `
    <div class="timeline-img"><p>{{ timeString || (dateValue | date:'HH:mm') }}</p></div>
    <div class="timeline-content">
      <div class="date"><p>{{ dateValue | date:'dd MMMM yyyy' }}</p></div>
      <div class="inner-content"><ng-content></ng-content></div>
    </div>
  `,
  styles: [`
    vertical-timeline-card { display: block; position: relative; margin-bottom: 36px; min-height: 80px; }
    vertical-timeline-card::after { content: ''; display: block; clear: both; }
    vertical-timeline-card .timeline-img { position: absolute; top: 40px; left: 20px; width: 60px; height: 60px;
      border-radius: 50%; display: flex; align-items: center; justify-content: center; color: white; }
    vertical-timeline-card .timeline-content { position: relative; margin-left: 70px; border-radius: 4px; min-height: 80px; }
    vertical-timeline-card .date { position: absolute; top: 0; right: 0; padding: 10px; color: white; }
    vertical-timeline-card .inner-content { padding-top: 32px; }
  `],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class VerticalTimelineCardComponent {
  @Input() dateValue!: Date;
  @Input() timeString?: string;
}

@NgModule({
  declarations: [VerticalTimelineComponent, VerticalTimelineCardComponent],
  imports: [CommonModule],
  exports: [VerticalTimelineComponent, VerticalTimelineCardComponent],
})
export class VerticalTimelineModule {}
